// https://github.com/jcoreio/material-ui-popup-state/commit/a68193f8b1e2c7882f44c7861471850d7be4763c#diff-1fc00d7a04bb306f70dd49d180a4ee179da1bd2bb10d5f15e016916567d7daaa
// https://github.com/vercel/next.js/issues/57285
export function interopRequireDefault(defaultImport) {
  const asAny = defaultImport;
  return asAny.__esModule ? asAny.default : defaultImport;
}
